//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalAmountRequested = ({ count }: { count: string | number }) => {
  return <StatCard title='Total Amount Requested' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalAmountRequested;
